export default {
    label_task:{
        en:"Seasons",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Season",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Season",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details Season",
        bn:'ব্যবহারকারীর বিবরণ'
    },


}